import React from 'react';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';
import classes from './textField.module.scss';
import colors from '../../../../scss/colors';

function TextField(props) {
  const errorPositions = {
    TOP: 'top',
    BOTTOM: 'bottom'
  };

  const {
    value,
    onChange,
    id,
    name,
    readOnly,
    type = 'text',
    disabled,
    label,
    error,
    errorText,
    placeholder,
    errorPosition = errorPositions.TOP,
    isTextArea = false,
    rows = '3',
    clearable,
    onClick,
    counter
  } = props;

  return (
    <div className={classes.container}>
      {!!label && <label htmlFor={id}>{label}</label>}
      {errorPosition === errorPositions.TOP && !!error && !!errorText && <ValidationErrorLabel message={errorText} />}
      {isTextArea ? (
        <textarea
          rows={rows}
          className={`${classes.inputElement} ${classes.textArea} ${clearable ? classes.clearable : ''}`}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          onClick={onClick}
        />
      ) : (
        <input
          className={`${classes.inputElement} ${clearable ? classes.clearable : ''}`}
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          onClick={onClick}
        />
      )}
      {!!counter && (
        <ValidationErrorLabel
          color={counter.qty > counter.limit ? colors.RED_ERROR : colors.LIGHT_GREY}
          message={`${counter.qty || '0'}/${counter.limit}`}
          fontSize="10px"
        />
      )}
      {errorPosition === errorPositions.BOTTOM && !!error && !!errorText && (
        <ValidationErrorLabel message={errorText} />
      )}
    </div>
  );
}

export default TextField;
